import SuperuserAnalytics from './SuperuserAnalytics';

const StaffAnalytics = () => <SuperuserAnalytics variant="staff" />;

export default StaffAnalytics;
